import { useAppContext } from "../context/AppContext";
import { AppScopes } from "../models/app-scopes.model";


type AppScopesState = { [key in `${AppScopes}Active`]: boolean };

export default function useAppScopes() {
  const {
    state: { scopes },
  } = useAppContext();

  const scopesState: AppScopesState = {
    uniqueIdActive: !!scopes?.includes("uniqueId"),
  };

  return {scopes,scopesState};
}
